import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { UserDetails } from 'src/app/Models/app-data';
import { HttpResponse } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class HelperService {

    constructor() { }

    //#region User Details Helper
    private loggedInUserDetails = new BehaviorSubject<UserDetails>(new UserDetails());
    userDetails = this.loggedInUserDetails.asObservable();

    setLoggedInUserDetails(data: UserDetails) {
        this.loggedInUserDetails.next(data);
    }
    //#endregion

    //#region Side Nav Toggle
    private isIconOnly = new BehaviorSubject<boolean>(false);
    isIconOnlyFlag = this.isIconOnly.asObservable();

    setSideNavFlag(data: boolean) {
        this.isIconOnly.next(data);
    }
    //#endregion
}
